import * as actionTypes from '../action-creator/actionTypes';
import * as systemActionTypes from '../../system/action-creator/actionTypes';
import * as appBarActionTypes from '../../app-bar/action-creator/actionTypes';
import { combineReducers } from 'redux';


const menuPaths = (state = [], action) => {
  switch(action.type){
    case systemActionTypes.LOAD_USER_UI_ACCESS:
      return action.paths;
    case systemActionTypes.LOGOUT_REQUEST:
      return [];
    default:
      return state;
  }
}

const opened = (state = false, action) => {
  switch(action.type){
    case actionTypes.TOGGLE_SIDE_BAR:
      return !state;
    case systemActionTypes.LOGOUT_REQUEST:
      return false;
    default:
      return state;
  }
}

const hidden = (state = false, action) => {
  switch(action.type){
    case appBarActionTypes.SET_APP_BAR_VISIBLITY:
      return !action.visible;
    default:
      return state;
  }
}

const selectedPath = (state = "", action) => {
  switch(action.type){
    case actionTypes.SET_SELECTED_PATH:
      return action.path
    default:
      return state;
  }
}

export default combineReducers({
  opened,
  hidden,
  selectedPath,
  menuPaths
});

const getCurrentState = state => state.mainSideBar;
export const getMenuPaths = state => getCurrentState(state).menuPaths;
export const isOpened = state => getCurrentState(state).opened;
export const isHidden = state => getCurrentState(state).hidden;
export const getSelectedPath = state => getCurrentState(state).selectedPath;